import { Form, InputNumber, Tooltip } from 'antd';
import Table from '@/components/ui/table/Table';
import { AppModal } from '@/components/ui/AppModal';
import { AppInput } from '@/components/ui/AppInput';
import { AppSelect } from '@/components/ui/AppSelect';

/**
 * Badge management tab UI only. Data and handlers from `useBadgeManagement` (via shell).
 */
export default function BadgeManagement({ screen }) {
    const {
        badgeRows,
        loading,
        badgeColumns,
        nextBadgeNumberPreview,
        badgeYearDefault,
        badgeCreateForm,
        createModalOpen,
        closeCreateModal,
        submitCreateModal,
        isCreating,
        branchOptions,
        onBadgeCreateFormValuesChange,
        createModalRequiresBranchPick,
    } = screen;

    const showBranchFieldInModal = createModalRequiresBranchPick;

    return (
        <>
            <Table
                title={null}
                columns={badgeColumns}
                dataSource={badgeRows}
                loading={loading}
                pagination
                pageSize={10}
                showSearch={false}
                showFilter={false}
                showMore={false}
            />

            <AppModal
                title="Create badge"
                open={createModalOpen}
                onCancel={closeCreateModal}
                onOk={() => void submitCreateModal()}
                confirmLoading={isCreating}
                okText="Save badge"
                size="md"
            >
                <Form
                    form={badgeCreateForm}
                    layout="vertical"
                    initialValues={{ year: badgeYearDefault }}
                    onValuesChange={onBadgeCreateFormValuesChange}
                >
                    {showBranchFieldInModal ? (
                        <Form.Item name="branchId" label="Campus" rules={[{ required: true, message: 'Select a campus' }]}>
                            <AppSelect
                                placeholder="Select campus"
                                options={branchOptions}
                                size="large"
                                showSearch
                                optionFilterProp="label"
                            />
                        </Form.Item>
                    ) : null}
                    <Form.Item label="Badge #">
                        <Tooltip title="Next number for this campus. Assigned when you save; not editable.">
                            <span style={{ display: 'block' }}>
                                <AppInput readOnly value={String(nextBadgeNumberPreview)} size="large" tabIndex={-1} />
                            </span>
                        </Tooltip>
                    </Form.Item>
                    <Form.Item name="title" label="Badge title" rules={[{ required: true, message: 'Enter badge title' }]}>
                        <AppInput placeholder="e.g. Spring intake" size="large" />
                    </Form.Item>
                    <Form.Item name="year" label="Year" rules={[{ required: true, message: 'Year is required' }]}>
                        <InputNumber min={1900} max={2100} style={{ width: '100%' }} />
                    </Form.Item>
                </Form>
            </AppModal>
        </>
    );
}
